var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modal_recruit_job_posting",
          attrs: {
            id: "modal-recruit-job-posting",
            title: _vm.title,
            size: "xl",
            "modal-class": "custom-modal",
            lazy: "",
            centered: "",
            scrollable: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          },
          on: { hidden: _vm.onHidden },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.hideModal }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          attrs: {
                            disabled: _vm.loading || _vm.isViewDisabled
                          },
                          on: { click: _vm.handleOk }
                        },
                        [
                          _vm.loading
                            ? _c("b-spinner", { attrs: { small: "" } })
                            : _vm._e(),
                          _vm._v("\n          Сохранить\n        ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("b-skeleton-wrapper", {
            attrs: { loading: _vm.isBusy },
            scopedSlots: _vm._u([
              {
                key: "loading",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-card",
                          { attrs: { "bg-variant": "light" } },
                          [
                            _c(
                              "b-row",
                              { staticClass: "mt-2 mb-2" },
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "21%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "3" } },
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "53%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "13%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "5%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "35%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "42%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-5" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "10%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "109%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "9%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "9%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "mb-2" },
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-skeleton", {
                                      staticClass: "mb-2",
                                      attrs: { width: "5%", height: "22%" }
                                    }),
                                    _vm._v(" "),
                                    _c("b-skeleton", {
                                      attrs: {
                                        type: "input",
                                        width: "100%",
                                        height: "44%"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "default",
                fn: function() {
                  return [
                    _c(
                      "b-form",
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { lg: "6" } },
                              [
                                _c(
                                  "b-card",
                                  { staticClass: "custom-card" },
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id:
                                                    "group-recruit-task-id-select",
                                                  label: "ID заявки на подбор"
                                                }
                                              },
                                              [
                                                _c("recruit-task-select", {
                                                  ref: "recruit_task_id_select",
                                                  attrs: {
                                                    "is-disabled":
                                                      _vm.selectDisabled ||
                                                      _vm.isViewDisabled,
                                                    state: _vm.getFieldState(
                                                      "recruit_task_id"
                                                    ),
                                                    value:
                                                      _vm.newItem
                                                        .recruit_task_id
                                                  },
                                                  on: {
                                                    onSelect:
                                                      _vm.onRecruitTaskIdSelect,
                                                    onClear: _vm.onClearSelected
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          { attrs: { cols: "6" } },
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-vacancy",
                                                  label: "Вакансия"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "text",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem
                                                        .location_vacancy_name,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "location_vacancy_name",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.location_vacancy_name"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-location",
                                          label: "Объект"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.location_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "location_name",
                                                $$v
                                              )
                                            },
                                            expression: "newItem.location_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-location-address",
                                          label: "Адрес объекта"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.isViewDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.location_address,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "location_address",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.location_address"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-opened-date",
                                                  label:
                                                    "Дата открытия вакансии"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "date",
                                                    disabled: _vm.isDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.opened_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "opened_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.opened_date"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-form-group",
                                              {
                                                attrs: {
                                                  id: "group-opened-date",
                                                  label: "Дата выхода в смену"
                                                }
                                              },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "date",
                                                    disabled: _vm.isViewDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.newItem.closed_date,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.newItem,
                                                        "closed_date",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "newItem.closed_date"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-vacancy-text",
                                          label: "Текст вакансии"
                                        }
                                      },
                                      [
                                        _c("b-form-textarea", {
                                          attrs: {
                                            type: "text",
                                            rows: 3,
                                            disabled: _vm.isViewDisabled
                                          },
                                          model: {
                                            value: _vm.newItem.text,
                                            callback: function($$v) {
                                              _vm.$set(_vm.newItem, "text", $$v)
                                            },
                                            expression: "newItem.text"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-organization",
                                          label: "Организация"
                                        }
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            type: "text",
                                            disabled: _vm.isDisabled
                                          },
                                          model: {
                                            value:
                                              _vm.newItem.organization_name,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.newItem,
                                                "organization_name",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "newItem.organization_name"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-assigned",
                                          label: "Ответственный"
                                        }
                                      },
                                      [
                                        _c("base-select", {
                                          attrs: {
                                            "is-disabled":
                                              _vm.isViewDisabled ||
                                              _vm.noLocationDisabled,
                                            options: _vm.assignedOptions,
                                            value: _vm.newItem.assigned,
                                            placeholder:
                                              "Выберите ответственного"
                                          },
                                          on: { onSelect: _vm.onSelectAssigned }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-status",
                                          label: "Статус"
                                        }
                                      },
                                      [
                                        _c("job-posting-status-select", {
                                          attrs: {
                                            "is-disabled": _vm.isViewDisabled,
                                            state: _vm.getFieldState(
                                              "status_id"
                                            ),
                                            value: _vm.newItem.status_id,
                                            "drop-up": ""
                                          },
                                          on: {
                                            onSelect:
                                              _vm.onSelectJobPostingStatus
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-card",
                                  { staticClass: "custom-card h-100" },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-provider-select",
                                          label: "Сервис"
                                        }
                                      },
                                      [
                                        _c("base-select", {
                                          attrs: {
                                            "is-disabled": _vm.isViewDisabled,
                                            options: _vm.providerOptions,
                                            value: _vm.newItem.provider_id,
                                            placeholder: "Выберите сервис"
                                          },
                                          on: { onSelect: _vm.onSelectProvider }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-business-area-select",
                                          label: "Сфера деятельности"
                                        }
                                      },
                                      [
                                        _c("base-select", {
                                          attrs: {
                                            "is-disabled":
                                              _vm.isAvitoFieldsDisabled,
                                            options:
                                              _vm.availableAvitoDictionaries,
                                            value: _vm.avitoData.business_area,
                                            placeholder:
                                              "Выберите сферу деятельности"
                                          },
                                          on: {
                                            onSelect:
                                              _vm.onSelectAvitoBusinessArea
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-experience-select",
                                          label: "Опыт работы"
                                        }
                                      },
                                      [
                                        _c("base-select", {
                                          attrs: {
                                            "is-disabled":
                                              _vm.isAvitoFieldsDisabled,
                                            options: _vm.experienceOptions,
                                            value: _vm.avitoData.experience,
                                            placeholder: "Укажите опыт работы"
                                          },
                                          on: {
                                            onSelect:
                                              _vm.onSelectAvitoExperience
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-employment-select",
                                          label: "Занятость"
                                        }
                                      },
                                      [
                                        _c("base-select", {
                                          attrs: {
                                            "is-disabled":
                                              _vm.isAvitoFieldsDisabled,
                                            options: _vm.employmentOptions,
                                            value: _vm.avitoData.employment,
                                            placeholder:
                                              "Выберите вид занятости"
                                          },
                                          on: {
                                            onSelect:
                                              _vm.onSelectAvitoEmployment
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-schedule-select",
                                          label: "График"
                                        }
                                      },
                                      [
                                        _c("base-select", {
                                          attrs: {
                                            "is-disabled":
                                              _vm.isAvitoFieldsDisabled,
                                            options: _vm.scheduleOptions,
                                            value: _vm.avitoData.schedule,
                                            placeholder:
                                              "Выберите график работы"
                                          },
                                          on: {
                                            onSelect: _vm.onSelectAvitoSchedule
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-avito-location",
                                          label: "Адрес для Авито"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "5" } },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "Город / населённый пункт",
                                                    disabled:
                                                      _vm.isAvitoFieldsDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.location
                                                        .address.locality,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.location
                                                          .address,
                                                        "locality",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.location.address.locality"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "5" } },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    placeholder: "Улица",
                                                    disabled:
                                                      _vm.isAvitoFieldsDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.location
                                                        .address.street,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.location
                                                          .address,
                                                        "street",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.location.address.street"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              { attrs: { cols: "2" } },
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    placeholder: "Дом",
                                                    disabled:
                                                      _vm.isAvitoFieldsDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.location
                                                        .address.house,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.location
                                                          .address,
                                                        "house",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.location.address.house"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          id: "group-salary-input",
                                          label: "Зарплата в месяц, ₽"
                                        }
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-3" },
                                          [
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    step: "1",
                                                    placeholder: "От",
                                                    disabled:
                                                      _vm.isAvitoFieldsDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.salary.from,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.salary,
                                                        "from",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.salary.from"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "number",
                                                    min: "0",
                                                    step: "1",
                                                    placeholder: "До",
                                                    disabled:
                                                      _vm.isAvitoFieldsDisabled
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.avitoData.salary.to,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.avitoData.salary,
                                                        "to",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression:
                                                      "avitoData.salary.to"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-group",
                                          { attrs: { label: "Картинка" } },
                                          [
                                            _c("b-form-file", {
                                              ref: "avitoImgInput",
                                              attrs: {
                                                disabled:
                                                  _vm.isAvitoFieldsDisabled ||
                                                  _vm.loading,
                                                size: "sm",
                                                placeholder:
                                                  "Картинка не выбрана",
                                                "browse-text": "Выбрать",
                                                accept:
                                                  "image/jpeg,image/png,image/gif,.jpg,.jpeg,.png,.gif"
                                              },
                                              on: { change: _vm.onFileChange }
                                            }),
                                            _vm._v(" "),
                                            _vm.avitoData.image_url
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "mt-2 d-flex align-items-center"
                                                  },
                                                  [
                                                    _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-success"
                                                      },
                                                      [
                                                        _c(
                                                          "font-awesome-icon",
                                                          {
                                                            staticClass: "mr-1",
                                                            attrs: {
                                                              icon:
                                                                "check-circle"
                                                            }
                                                          }
                                                        ),
                                                        _vm._v(
                                                          "\n                        Изображение загружено\n                      "
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "small ml-2",
                                                        attrs: {
                                                          href:
                                                            _vm.avitoData
                                                              .image_url,
                                                          target: "_blank",
                                                          rel:
                                                            "noopener noreferrer"
                                                        }
                                                      },
                                                      [_vm._v("Открыть")]
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.avitoData.last_error
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "alert alert-danger py-2"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("Ошибка Авито:")
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.avitoData.last_error
                                                ) +
                                                "\n                    "
                                            ),
                                            _vm.avitoStatusText
                                              ? _c(
                                                  "div",
                                                  { staticClass: "mt-1" },
                                                  [
                                                    _c("small", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.avitoStatusText
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm.hasAvitoPublication
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "alert alert-info py-2"
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v("Статус Авито:")
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.avitoStatusText) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "w-100 d-flex justify-content-end mt-auto"
                                      },
                                      [
                                        !_vm.hasAvitoIntegration &&
                                        !_vm.loading &&
                                        _vm.newItem.provider_id === 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "alert alert-danger m-0 py-1 px-2 mr-2 d-flex align-items-center",
                                                staticStyle: {
                                                  "font-size": "0.85rem",
                                                  "border-style": "dashed"
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    icon: "exclamation-triangle"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      id: "orgIntegration"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "У организации нет интеграции с Авито"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("b-tooltip", {
                                                  attrs: {
                                                    target: "orgIntegration",
                                                    title:
                                                      "Укажите ключи интеграции в карточке организации.",
                                                    triggers: "hover"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.avitoVacancyURL
                                          ? _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "custom-btn-secondary mr-2",
                                                attrs: {
                                                  href: _vm.avitoVacancyURL,
                                                  target: "_blank",
                                                  rel: "noopener noreferrer"
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  staticClass: "mr-1",
                                                  attrs: {
                                                    icon: "external-link-alt"
                                                  }
                                                }),
                                                _vm._v(
                                                  "\n                      Открыть на Авито\n                    "
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "custom-btn-primary",
                                            attrs: {
                                              disabled:
                                                _vm.loading ||
                                                _vm.isAvitoFieldsDisabled
                                            },
                                            on: { click: _vm.publishToAvito }
                                          },
                                          [
                                            _vm.loading
                                              ? _c("b-spinner", {
                                                  attrs: { small: "" }
                                                })
                                              : [
                                                  _c("font-awesome-icon", {
                                                    staticClass: "mr-1",
                                                    attrs: {
                                                      icon: _vm.avitoActionIcon
                                                    }
                                                  }),
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.avitoActionLabel
                                                      ) +
                                                      "\n                      "
                                                  )
                                                ]
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43b51d70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43b51d70","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitJobPosting.vue
// module id = null
// module chunks = 